.atm_9s_1txwivl{display:flex;}
.atm_h_1h6ojuz.atm_h_1h6ojuz{align-items:center;}
.atm_e2_1vi7ecw{height:32px;}
.atm_2d_1byrjjm.atm_2d_1byrjjm{background-color:#E7EBEE;}
.atm_5j_i2wt44{border-radius:6px;}
.atm_l8_yh40bf{padding:2px;}
.atm_vy_1ns9ob4{width:fit-content;}
.atm_cx_1y44olf{gap:4px;}
.atm_l8_1cudcw5{padding:4px 8px;}
.atm_5j_1y44olf{border-radius:4px;}
.atm_26_1j28jx2{background:transparent;}
.atm_70_glywfm{box-shadow:none;}
.atm_e2_1f4h9lt{height:28px;}
.atm_tej1as_qgx6rq svg{color:#6F7780;}
.atm_1dlbvfv_exct8b svg{height:16px;}
.atm_1x6ukr8_exct8b svg{min-height:16px;}
.atm_1pqnrs9_exct8b svg{width:16px;}
.atm_1wqwlc2_exct8b svg{min-width:16px;}
.atm_xntznv_4jg895.atm_xntznv_4jg895 .content-switcher-label{font-weight:normal;}
.atm_meiqq5_qgx6rq .content-switcher-label{color:#6F7780;}
.atm_1y17hwk_j1e0tf.atm_1y17hwk_j1e0tf:hover{background-color:#CED3DA;}
.atm_1kevezh_1j28jx2:active{background:transparent!important;}
.atm_16scgop_1hutuam:active{color:#202328!important;}
.atm_1o0kpsp_qgx6rq:active svg{color:#6F7780!important;}
.atm_1yl5u20_1oy2gec:focus-visible{box-shadow:0px 1px 1px 0px rgba(0, 33, 82, 0.15),0px 1px 3px 1px rgba(0, 33, 82, 0.15);}
.atm_26_1pec9uq{background:#ffffff;}
.atm_70_1oy2gec{box-shadow:0px 1px 1px 0px rgba(0, 33, 82, 0.15),0px 1px 3px 1px rgba(0, 33, 82, 0.15);}
.atm_xntznv_1fw03zg.atm_xntznv_1fw03zg .content-switcher-label{font-weight:700;}
.atm_meiqq5_1hutuam .content-switcher-label{color:#202328;}
.atm_1y17hwk_1pec9uq.atm_1y17hwk_1pec9uq:hover{background-color:#ffffff;}
.atm_1kevezh_1pec9uq:active{background:#ffffff!important;}
